import Link from 'next/link'
import tw, { styled } from 'twin.macro'

type ContainerProps = {
  active: boolean
}

const hoverStyle = tw`hover:bg-primary-indigo hover:bg-opacity-8`
const activeStyle = tw`bg-primary-indigo text-white`
const disabledStyle = tw`cursor-default`

const Container = styled.a<ContainerProps>`
  ${tw`flex justify-center items-center rounded-full`}

  cursor:pointer;
  height: 28px;
  width: 28px;
  font-size: 14px;

  ${(props) => props.active && activeStyle}
  ${(props) => !props.active && props.onClick && hoverStyle}
  ${(props) => !props.onClick && disabledStyle}
`

type Props = {
  children: '...' | number
  active: boolean
  href?: string
  rel?: string
}

function NumberButton(props: Props) {
  const { children = '...', active, href, rel } = props

  const childrenWithContainer = (
    <Container active={active} rel={rel}>
      {children}
    </Container>
  )

  if (!href) return childrenWithContainer

  return (
    <Link href={href} passHref>
      {childrenWithContainer}
    </Link>
  )
}

export default NumberButton
